export default __webpack_public_path__ + "static/media/banner.c515f0bf.png";